// export const logout = ( state ) => {
// }

export const setClients = (state, clients) => {
    state.clients = clients
}

export const setClientsSelectable = (state, clients) => {
    state.clientsSelectable = clients
}

export const setClientSelect = ( state, client ) => {
    state.clientSelect = client
}


export const setClientsPaginated = (state, clientsPaginatedData) => {
    state.clientsPaginatedData = clientsPaginatedData
}

export const setClientDetail = (state, client) => {
    state.client = client
}

export const saveNewClients = (state, client) => {
    state.clients.unshift(client)
    state.createdData = client;
}

export const saveUpdatedClient = (state, client) => {
    state.clients.unshift(client)
    state.updatedData = client;
}

export const setDeleteClient = (state, client) => {
    state.clientsPaginatedData.data.filter(x => x.id !== client.id);
    state.deletedData = client
}

export const setClientIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setClientIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setClientIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setClientIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setClientProductsIsLoading = (state, isLoadingClientProducts) => {
    state.isLoadingClientProducts = isLoadingClientProducts
}

export const setClientProducts = (state, clientProducts) => {
    state.clientProducts = clientProducts
}

export const setClientInputsLength = (state, clientInputsLength) => {
    state.clientInputsLength = clientInputsLength
}

export const setClientOutputsLength = (state, clientOutputsLength) => {
    state.clientOutputsLength = clientOutputsLength
}